import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MapComponent } from '@core/components/map/map.component';
import { IconModule } from '@core/components/icon/icon.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [MapComponent],
  imports: [CommonModule, LeafletModule, IconModule, RouterModule],
  exports: [MapComponent]
})
export class MapModule {}
